import type { DocPageContent } from '../docs-content'

const page = {
  order: 19,
  slug: 'render-queue',
  title: '渲染队列',
  description:
    '将多个导出加入队列、把渲染拆分为片段、管理队列，以及查找已保存的文件。',
  category: '输出',
  related: ['export'],
  sections: [
    {
      title: '将导出加入队列',
      blocks: [
        {
          kind: 'list',
          items: [
            '在导出对话框中，选择**加入队列**而非立即渲染。',
            '将整个项目或当前范围加入队列。',
            '随时可从工具栏的**渲染队列**按钮打开队列，它会显示实时任务数量。',
          ],
        },
        {
          kind: 'note',
          tone: 'info',
          text: '排队的导出会逐个渲染，并保存到工作区中的导出文件夹。',
        },
      ],
    },
    {
      title: '拆分为片段',
      blocks: [
        {
          kind: 'list',
          items: [
            '**拆分为片段**会将一次渲染拆分为多个任务。',
            '使用**每个标记一个片段**可在时间轴标记处拆分渲染。',
            '或按设定的秒数拆分为固定大小的块。',
          ],
        },
      ],
    },
    {
      title: '管理队列',
      blocks: [
        {
          kind: 'list',
          items: [
            '**暂停**和**继续**队列以控制渲染的时机。',
            '将排队的任务**上移**或**下移**以更改其顺序。',
            '**取消**正在运行或排队的任务，**重试**失败的任务，并**移除**已完成的任务。',
            '任务状态显示为已排队、渲染中、完成、失败或已取消；使用**清除已完成**或**清除全部**进行整理。',
          ],
        },
      ],
    },
    {
      title: '已保存的导出',
      blocks: [
        {
          kind: 'list',
          items: [
            '切换到**已保存导出**标签页以查看已完成的文件。',
            '从那里下载或删除已保存的导出。',
            '这些文件位于你工作区内该项目的文件夹中。',
          ],
        },
      ],
    },
  ],
} satisfies DocPageContent

export default page
